import { App } from 'vue'
import { logger } from '@/instance'

export default {
  install(app: App, opt: any) {
    app.directive('scroll', {
      mounted(el: any, binding) {
        logger.log('plugins/scroll-left', 'scroll-left mounted', arguments)
        binding.value && el.scrollIntoView()
      },
    })

    app.directive('scroll-left', {
      /**
       *
       * data-binding scrollLeft
       * @param {*} el
       * @param {*} binding
       */
      mounted(el: any, binding) {
        logger.log('plugins/scroll-left', 'scroll-left mounted', arguments)
        const callback = binding.arg as unknown as (val: number) => void
        el.onscroll = (e: Event) => {
          console.log(e)
          callback && callback(el.scrollLeft)
        }
        binding.value !== binding.oldValue &&
          el.scrollTo({
            left: binding.value,
            behavior: 'smooth',
          })
      },
      updated(el: any, binding) {
        binding.value !== binding.oldValue &&
          el.scrollTo({
            left: binding.value,
            behavior: 'smooth',
          })
      },
      beforeUnmount(el: any) {
        logger.log(
          'plugins/scroll-left',
          'scroll-left before unmounted',
          arguments
        )
        el.onscroll = null
      },
    })
    app.directive('scroll-top', {
      /**
       *
       * data-binding scrollLeft
       * @param {*} el
       * @param {*} binding
       */
      mounted(el: any, binding) {
        logger.log('plugins/scroll-top', 'scroll-top mounted', arguments)
        const callback = binding.arg as unknown as (val: number) => void
        el.onscroll = (e: Event) => {
          console.log(e)
          callback && callback(el.scrollLeft)
        }
        binding.value !== binding.oldValue &&
          el.scrollTo({
            top: binding.value,
            behavior: 'smooth',
          })
      },
      updated(el: any, binding) {
        binding.value !== binding.oldValue &&
          el.scrollTo({
            top: binding.value,
            behavior: 'smooth',
          })
      },
      beforeUnmount(el: any) {
        logger.log(
          'plugins/scroll-top',
          'scroll-top before unmounted',
          arguments
        )
        el.onscroll = null
      },
    })
  },
}
